import { FaSadTear } from 'react-icons/fa';
import './empty.css';

const Empty = ({text}) => {

      return (
            <div className="empty_content">
                  <span><FaSadTear /></span>
                  <h3>{text}</h3>
            </div>
      )
}

export default Empty;